// extracted by mini-css-extract-plugin
export default {"container":"TranslationsForm_container__euTYH"};